import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { getWhatsappOpeningMessagesQueryKey } from "modules/campaigns/lib/templates/openingMessages/whatsappOpeningMessagesQuery"
import { useTranslation } from "react-i18next"
import { toast } from "sonner"

export const useArchiveWhatsappOpeningMessageMutation = () => {
  const { t } = useTranslation()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (id: string) => {
      const { data } = await axios.delete(`/integrations/whatsapp/opening-messages/${id}`)
      return data.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: getWhatsappOpeningMessagesQueryKey() })
      toast.success(t("campaigns.templates.openingMessages.archivedSuccess"))
    },
  })
}
